import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import moment from "moment";
import {
  Field,
  reduxForm,
  reset,
  submit,
  stopSubmit,
  setSubmitFailed,
} from "redux-form";
import NoContentAdded, { NO_REVIEWER } from "NoContentAdded";
import Pagination from "react-js-pagination";
import {
  IMAGE_PATH,
  itemCount,
  COMMON_FAIL_MESSAGE,
  DATE_FORMAT_WITH_TIME,
} from "Constants";
import { BaseComponent, LABEL_POSITION_TOP } from "BaseComponent";
import { showError, showSuccess } from "ReduxErrorBar";
import { Modal } from "react-bootstrap";
import Button from "react-bootstrap-button-loader";
import LocaleStrings from "Languages";
import { addAppUser, sendShortlistedEmail } from "DashboardUserAction";
import {
  openProposalConfirmModal,
  createExhibitor,
  createSponsor,
  fetchallproposal,
  updatedDragProposal,
  openProposalResponseModal,
  fetchAllAttendies,
} from "ProposalAction";
import { fetchAllSpeakers, createSpeaker } from "ActionsSpeakers";
import { fetchAllExhibitors, insertExhibitor } from "ActionsExhibitors";
import { fetchAllSponsors, insertSponsor } from "ActionsSponsors";
import { validateEmailForAppUser } from "DashboardMenuAction";
var Loader = require("react-loaders").Loader;

class ProposalConfirm extends BaseComponent {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
    this.state = {
      loading: false,
      loaderPopulate: false,
      selectedCategory: "",
      associated: true,
    };
  }

  componentDidMount() {}

  closeModal() {
    this.props.openProposalConfirmModal(false, "");
  }

  renderFieldRadio(field) {
    return (
      <div>
        <label
          className="custom-container-radio liveqa-label"
          style={{ marginBottom: 5 }}
        >
          {field.label}
          <input {...field.input} type={field.type} />
          <span className="radiomark"></span>
        </label>
      </div>
    );
  }

  onSubmitForm = (values) => {
    var { proposalConfirmModal, session, userCategoryList, sponsorCategories } =
      this.props;

    let field = "";
    let newfield = "";
    let createAction = "";
    if (values.categoryid == "speaker") {
      field = "speakeridfk";
      newfield = "speakerid";
      createAction = "createSpeaker";
    } else if (values.categoryid == "sponsor") {
      field = "sponsoridfk";
      newfield = "sponsorid";
      createAction = "createSponsor";
    } else if (values.categoryid == "exhibitor") {
      field = "exhibitoridfk";
      newfield = "exhibitorid";
      createAction = "createExhibitor";
    }

    //console.log(values);

    values.firstname = proposalConfirmModal.response.firstname;
    values.lastname = proposalConfirmModal.response.lastname;
    values.email = proposalConfirmModal.response.email;
    values.eventid = session.eventid;
    if (values.categoryid == "sponsor" || values.categoryid == "exhibitor") {
      values.name =
        proposalConfirmModal.response.firstname +
        " " +
        proposalConfirmModal.response.lastname;
    }

    let uservalues = {};
    var speakerDetails = _.filter(userCategoryList.data, (obj) => {
      return obj.type == values.categoryid;
    });
    uservalues.usercategory =
      speakerDetails.length > 0 ? speakerDetails[0].id : "";
    uservalues.username =
      proposalConfirmModal.response.firstname +
      " " +
      proposalConfirmModal.response.lastname;
    uservalues.firstname = proposalConfirmModal.response.firstname;
    uservalues.lastname = proposalConfirmModal.response.lastname;

    uservalues.email = proposalConfirmModal.response.email;
    uservalues.eventid = session.eventid;
    uservalues.comesfrom = "proposal";
    uservalues.isadmin = 0;
    if (
      (values.categoryid == "speaker" ||
        values.categoryid == "sponsor" ||
        values.categoryid == "exhibitor") &&
      values.associated == "1"
    ) {
      uservalues[field] = values[field].id;
    }
    //console.log(values);
    //console.log(uservalues);
    this.setState({ loading: true });
    if (
      (values.categoryid == "speaker" ||
        values.categoryid == "sponsor" ||
        values.categoryid == "exhibitor") &&
      values.associated == "2"
    ) {
      this.props.validateEmailForAppUser(
        this.props.session,
        uservalues,
        (validationresponse) => {
          if (validationresponse.success === 2) {
            this.props.showError(validationresponse.message);
            this.setState({ loading: false });
            this.closeModal();
          } else if (validationresponse.success == 1) {
            //console.log("sponsorCategories", sponsorCategories);
            if (sponsorCategories.data && sponsorCategories.data.length > 0) {
              values.categoryid = sponsorCategories.data[0].id;
            }

            //console.log("values", values);
            this.props[createAction](this.props.session, values, (feedback) => {
              if (feedback.success === 0) {
                this.props.showError(COMMON_FAIL_MESSAGE);
              } else {
                var referenceid = feedback[newfield];
                uservalues[field] = referenceid ? referenceid : null;
                //console.log('values',uservalues);

                this.props.addAppUser(
                  this.props.session,
                  uservalues,
                  (response1) => {
                    if (response1.success === 0) {
                      this.setState({ loading: false });
                      this.props.showError(COMMON_FAIL_MESSAGE);
                    } else {
                      this.props.sendShortlistedEmail(
                        this.props.session,
                        this.props.templateData,
                        { email: uservalues.email },
                        (response2) => {
                          //console.log("response2 second", response2);
                          if (response2.success === 1) {
                            this.props.fetchallproposal(
                              this.props.session,
                              (callback) => {
                                this.props.fetchAllAttendies(
                                  this.props.session
                                );
                                this.props.updatedDragProposal(true);
                                this.setState({ loading: false });
                                this.closeModal();
                                this.props.openProposalResponseModal(
                                  false,
                                  "",
                                  ""
                                );
                                this.props.showSuccess(
                                  LocaleStrings.user_message_welcome_email_sent
                                );
                              }
                            );
                          } else {
                            this.props.showError(COMMON_FAIL_MESSAGE);
                            this.setState({ loading: false });
                          }
                          //proposalConfirmModal.handleSelect("shortlisted");
                          // this.props.handleSelect("shortlisted");
                        }
                      );
                    }
                  }
                );
              }
            });
          } else {
            this.setState({ loading: false });
            this.props.showError(COMMON_FAIL_MESSAGE);
            this.closeModal();
          }
        }
      );
    } else if (
      (values.categoryid == "speaker" ||
        values.categoryid == "sponsor" ||
        values.categoryid == "exhibitor") &&
      values.associated == "1"
    ) {
      this.props.validateEmailForAppUser(
        this.props.session,
        uservalues,
        (validationresponse) => {
          if (validationresponse.success === 2) {
            this.props.showError(validationresponse.message);
            this.setState({ loading: false });
            this.closeModal();
          } else if (validationresponse.success == 1) {
            this.props.addAppUser(
              this.props.session,
              uservalues,
              (response1) => {
                if (response1.success === 0) {
                  this.setState({ loading: false });
                  this.props.showError(COMMON_FAIL_MESSAGE);
                  this.closeModal();
                } else {
                  this.props.sendShortlistedEmail(
                    this.props.session,
                    this.props.templateData,
                    { email: uservalues.email },
                    (response2) => {
                      //console.log("response2 second", response2);
                      if (response2.success === 1) {
                        this.props.fetchallproposal(
                          this.props.session,
                          (callback) => {
                            this.props.fetchAllAttendies(this.props.session);
                            this.props.updatedDragProposal(true);
                            this.setState({ loading: false });
                            this.closeModal();
                            this.props.reset();
                            this.props.openProposalResponseModal(false, "", "");
                            this.props.showSuccess(
                              LocaleStrings.user_message_welcome_email_sent
                            );
                          }
                        );
                      } else {
                        this.props.showError(COMMON_FAIL_MESSAGE);
                        this.setState({ loading: false });
                      }

                      //proposalConfirmModal.handleSelect("shortlisted");
                      // this.props.handleSelect("shortlisted");
                    }
                  );
                }
              }
            );
          } else {
            this.setState({ loading: false });
            this.props.showError(COMMON_FAIL_MESSAGE);
            this.closeModal();
          }
        }
      );
    } else {
      this.props.validateEmailForAppUser(
        this.props.session,
        uservalues,
        (validationresponse) => {
          if (validationresponse.success === 2) {
            this.props.showError(validationresponse.message);
            this.setState({ loading: false });
            this.closeModal();
          } else if (validationresponse.success == 1) {
            this.props.addAppUser(
              this.props.session,
              uservalues,
              (response1) => {
                if (response1.success === 0) {
                  this.setState({ loading: false });
                  this.props.showError(COMMON_FAIL_MESSAGE);
                  this.closeModal();
                } else {
                  this.props.sendShortlistedEmail(
                    this.props.session,
                    this.props.templateData,
                    { email: uservalues.email },
                    (response2) => {
                      //console.log("response2 second", response2);
                      if (response2.success === 1) {
                        this.props.fetchallproposal(
                          this.props.session,
                          (callback) => {
                            this.props.fetchAllAttendies(this.props.session);
                            this.props.updatedDragProposal(true);
                            this.setState({ loading: false });
                            this.closeModal();
                            this.props.openProposalResponseModal(false, "", "");
                            this.props.showSuccess(
                              LocaleStrings.user_message_welcome_email_sent
                            );
                          }
                        );
                      } else {
                        this.props.showError(COMMON_FAIL_MESSAGE);
                        this.setState({ loading: false });
                      }
                    }
                  );
                }
              }
            );
          } else {
            this.setState({ loading: false });
            this.props.showError(COMMON_FAIL_MESSAGE);
            this.closeModal();
          }
        }
      );
    }
  };

  check = (str, val) => {
    return str.split(",").includes(val + "");
  };

  renderCustomSelect = (field) => {
    var divClassName = `form-group ${
      field.meta.touched && field.meta.error ? "has-danger" : ""
    }`;

    var fieldcss = "form-control dropdown-height-border";

    return (
      <div className={divClassName}>
        <label className="">
          {field.label}
          <span className="label-mandatory">
            {field.mandatory === "true" ? "*" : ""}
          </span>
        </label>
        {/* <div className="col-sm-9 col-sm-offset-0"> */}
        <select className={fieldcss} {...field.input}>
          <option value="" key={field.label}>
            {field.placeholder}
          </option>
          {field.opts.map((object, index) => {
            return (
              <option key={index} value={object.value}>
                {object.name}
              </option>
            );
          })}
        </select>
        <div className="text-help label-text-help">
          {field.meta.touched ? field.meta.error : ""}
        </div>
        {/* </div> */}
      </div>
    );
  };
  handleAssociation = (e) => {
    var selected = e.target.value;
    this.setState({ associated: selected });
  };
  handleCategory = (e) => {
    var selected = e.target.value;
    this.setState({ associated: 2 });
    if (selected) {
      this.setState({ selectedCategory: selected });
      this.props.autofill("associated", "2");
      switch (selected) {
        case "sponsor":
          this.setState({ loaderPopulate: true });
          this.props.fetchAllSponsors(this.props.session, (res) => {
            this.setState({ loaderPopulate: false });
          });

          break;
        case "speaker":
          this.setState({ loaderPopulate: true });
          this.props.fetchAllSpeakers(this.props.session, (res) => {
            this.setState({ loaderPopulate: false });
          });
          break;
        case "exhibitor":
          this.setState({ loaderPopulate: true });
          this.props.fetchAllExhibitors(this.props.session, (res) => {
            this.setState({ loaderPopulate: false });
          });
          break;
        default:
          this.setState({ loaderPopulate: false });
          break;
      }
    } else {
      this.setState({ selectedCategory: selected });
    }
  };

  render() {
    var {
      handleSubmit,
      pristine,
      reset,
      submitting,
      invalid,
      proposalConfirmModal,
      userCategoryList,
      allSpeakers,
      allExhibitors,
      allSponsors,
      initialValues,
      sponsorCategories,
      handleSelect,
    } = this.props;
    var { loaderPopulate, selectedCategory, associated } = this.state;
    //console.log("sponsorCategories", sponsorCategories);
    // console.log("allExhibitors", allExhibitors);
    // console.log("allSponsors", allSponsors);
    var tickets = [];

    if (
      userCategoryList &&
      userCategoryList.data &&
      userCategoryList.data.length > 0
    ) {
      userCategoryList.data.forEach((item, index) => {
        if (item.type != "admin") {
          var obj = { name: `${item.groupname}`, value: item.type };
          tickets.push(obj);
        }
      });
    }
    var catarr = ["sponsor", "exhibitor", "speaker"];
    var speakerOptions = [];
    var sponsorOptions = [];
    var exhibitorOptions = [];

    if (
      selectedCategory == "speaker" &&
      allSpeakers &&
      allSpeakers.data &&
      allSpeakers.data.length > 0
    ) {
      allSpeakers.data.forEach((item, index) => {
        var obj = {
          label: `${item.firstname} ${item.lastname}`,
          name: `${item.firstname} ${item.lastname}`,
          id: item.speakerid.toString(),
        };
        speakerOptions.push(obj);
      });
    }
    // console.log('speakerOptions : - ', speakerOptions);

    if (
      selectedCategory == "sponsor" &&
      allSponsors &&
      allSponsors.data &&
      allSponsors.data.length > 0
    ) {
      allSponsors.data.forEach((item, index) => {
        var obj = {
          label: `${item.name}`,
          name: `${item.name}`,
          id: item.sponsorid.toString(),
        };
        sponsorOptions.push(obj);
      });
    }
    // console.log('sponsorOptions : - ', sponsorOptions);

    if (
      selectedCategory == "exhibitor" &&
      allExhibitors &&
      allExhibitors.data &&
      allExhibitors.data.length > 0
    ) {
      allExhibitors.data.forEach((item, index) => {
        var obj = {
          label: `${item.name}`,
          name: `${item.name}`,
          id: item.exhibitorid.toString(),
        };
        exhibitorOptions.push(obj);
      });
    }
    return (
      <div>
        <Modal
          className="modal-container"
          enforceFocus={false}
          show={proposalConfirmModal.showModal === true ? true : false}
          animation={true}
        >
          <Modal.Header>
            <div className="import-modal-title">
              {LocaleStrings.proposal_confirm}
            </div>
            <button
              type="button"
              className="i-custom-cross-popup pull-right"
              onClick={() => this.closeModal()}
            >
              <img
                className="i-custom-small"
                src="../../style/images/custom-icons/cross-black.png"
              />
            </button>
          </Modal.Header>
          <form onSubmit={handleSubmit(this.onSubmitForm)}>
            <Modal.Body>
              <div style={{ textAlign: "right", paddingBottom: 10 }}>
                Email: <b>{proposalConfirmModal.response.email}</b>
              </div>
              <Field
                name="categoryid"
                label="Choose Category"
                type="select"
                component={this.renderCustomSelect}
                mandatory="true"
                placeholder="Select Category"
                opts={tickets}
                onChange={this.handleCategory}
              />
              {catarr.includes(selectedCategory) ? (
                loaderPopulate ? (
                  <div>
                    <Loader
                      type="line-scale-pulse-out-rapid"
                      active
                      className="loader-div"
                    />
                  </div>
                ) : selectedCategory == "sponsor" ? (
                  <div className="form-group row">
                    <div className="col-sm-6 col-sm-offset-0">
                      <div style={{ marginBottom: 5 }}>
                        <Field
                          name="associated"
                          label="Create New"
                          value="2"
                          type="radio"
                          component={this.renderFieldRadio}
                          onChange={this.handleAssociation}
                        />
                      </div>
                    </div>
                    <div className="col-sm-6 col-sm-offset-0">
                      <div style={{ marginBottom: 5 }}>
                        <Field
                          name="associated"
                          label="Associate User"
                          value="1"
                          type="radio"
                          component={this.renderFieldRadio}
                          onChange={this.handleAssociation}
                        />
                      </div>
                    </div>

                    {associated == 1 ? (
                      <div className="col-sm-12 col-sm-offset-0">
                        <Field
                          name="sponsoridfk"
                          label={LocaleStrings.user_form_label_sponsor}
                          placeholder={
                            LocaleStrings.user_form_label_sponsor_placeholder
                          }
                          component={this.renderAutoComplete}
                          mandatory="false"
                          options={sponsorOptions}
                          labelKey="name"
                          valueKey="id"
                        />
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                ) : selectedCategory == "speaker" ? (
                  <div className="form-group row">
                    <div className="col-sm-6 col-sm-offset-0">
                      <div style={{ marginBottom: 5 }}>
                        <Field
                          name="associated"
                          label="Create New"
                          value="2"
                          type="radio"
                          component={this.renderFieldRadio}
                          onChange={this.handleAssociation}
                        />
                      </div>
                    </div>
                    <div className="col-sm-6 col-sm-offset-0">
                      <div style={{ marginBottom: 5 }}>
                        <Field
                          name="associated"
                          label="Associate User"
                          value="1"
                          type="radio"
                          component={this.renderFieldRadio}
                          onChange={this.handleAssociation}
                        />
                      </div>
                    </div>
                    {associated == 1 ? (
                      <div className="col-sm-12 col-sm-offset-0">
                        <Field
                          name="speakeridfk"
                          label={LocaleStrings.user_form_label_speaker}
                          placeholder={
                            LocaleStrings.user_form_label_speaker_placeholder
                          }
                          component={this.renderAutoComplete}
                          mandatory="false"
                          options={speakerOptions}
                          labelKey="name"
                          valueKey="id"
                        />
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                ) : selectedCategory == "exhibitor" ? (
                  <div className="form-group row">
                    <div className="col-sm-6 col-sm-offset-0">
                      <div style={{ marginBottom: 5 }}>
                        <Field
                          name="associated"
                          label="Create New"
                          value="2"
                          type="radio"
                          component={this.renderFieldRadio}
                          onChange={this.handleAssociation}
                        />
                      </div>
                    </div>
                    <div className="col-sm-6 col-sm-offset-0">
                      <div style={{ marginBottom: 5 }}>
                        <Field
                          name="associated"
                          label="Associate User"
                          value="1"
                          type="radio"
                          component={this.renderFieldRadio}
                          onChange={this.handleAssociation}
                        />
                      </div>
                    </div>
                    {associated == 1 ? (
                      <div className="col-sm-12 col-sm-offset-0">
                        <Field
                          name="exhibitoridfk"
                          label={LocaleStrings.user_form_label_exhibitor}
                          placeholder={
                            LocaleStrings.user_form_label_exhibitor_placeholder
                          }
                          component={this.renderAutoComplete}
                          mandatory="false"
                          options={exhibitorOptions}
                          labelKey="name"
                          valueKey="id"
                        />
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                ) : (
                  ""
                )
              ) : (
                ""
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button
                className="btn btn-custom-white"
                bsStyle=""
                onClick={this.closeModal}
              >
                {LocaleStrings.button_close}
              </Button>
              <Button
                className="btn btn-custom-blue ml-10"
                bsStyle=""
                loading={this.state.loading}
                disabled={pristine || invalid || submitting}
                type="submit"
              >
                {LocaleStrings.proposal_confirm_button}
              </Button>
            </Modal.Footer>
          </form>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  let initVals = { associated: "2" };
  var templateData = null;
  if (
    state.templateData &&
    state.templateData.resource &&
    state.templateData.resource.length > 0
  ) {
    templateData = state.templateData.resource[0];
  }
  return {
    session: state.session,
    proposalConfirmModal: state.proposalConfirmModal,
    userCategoryList: state.userCategoryList,
    eventDetails: state.userEventDetails,
    allSpeakers: state.allSpeakers,
    allExhibitors: state.allExhibitors,
    allSponsors: state.allSponsors,
    initialValues: initVals,
    templateData,
    sponsorCategories: state.sponsorCategories,
  };
}

function validate(values) {
  var errors = {};
  var categoryid = values["categoryid"];
  var proposaldesc = values["proposaldesc"];

  if (!categoryid) {
    errors["categoryid"] = LocaleStrings.required;
  }

  return errors;
}

export default connect(mapStateToProps, {
  showError,
  showSuccess,
  openProposalConfirmModal,
  createExhibitor,
  fetchAllSpeakers,
  createSpeaker,
  fetchAllExhibitors,
  insertExhibitor,
  fetchAllSponsors,
  insertSponsor,
  validateEmailForAppUser,
  addAppUser,
  createSponsor,
  fetchallproposal,
  updatedDragProposal,
  openProposalResponseModal,
  fetchAllAttendies,
  sendShortlistedEmail,
})(
  reduxForm({
    validate,
    form: "ConfirmForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(ProposalConfirm)
);
